import { createContext, useContext } from 'react';
interface ConfirmDownloadModalContextProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (isDialogOpen: boolean) => void;
}
const ConfirmDownloadModalContext = createContext<ConfirmDownloadModalContextProps>({
  isDialogOpen: false,
  setIsDialogOpen: () => {
    /* noop */
  }
});
ConfirmDownloadModalContext.displayName = 'ConfirmDownloadModalContext';
const useConfirmDownloadModalContext = () => {
  const context = useContext(ConfirmDownloadModalContext);
  if (!context) {
    throw new Error('useConfirmDownloadModalContext must be used within a ConfirmDownloadModalContext.Provider');
  }
  return context;
};
export { ConfirmDownloadModalContext, useConfirmDownloadModalContext };